import React, { FunctionComponent } from "react"
import "./NotAllowed.css"

const NotAllowed: FunctionComponent<{}> = () => {

    const email = process.env.REACT_APP_USER_SUPPORT_EMAIL

    return (
        <div className="NotAllowed main-content col-sm">
            <div className="NotAllowedContent">
                <span className="material-icons e2c697db48618a579c3b412a7967">lock</span>
                <div className="NotAllowedContentText">
                    <p>You dont have access to be here</p>
                </div>
                <div className="NotAllowedContentHelp">
                    <p>If you think this is an error please contact help desk at:</p>
                    <a href={`mailto:${email}`}>{email}</a>
                </div>
            </div>
        </div>
    )
}

export default NotAllowed